import $ from "jquery";
import swal from "sweetalert";
import I18n from "i18n-js";

// $(document).on('turbolinks:load', function () {

    /*REGISTRATION FORM*/
    const regForm             = document.querySelector('form#pre-registration');

    const firstNameEl         = document.querySelector('#first_name');
    const lastNameEl          = document.querySelector('#last_name');
    const emailEl             = document.querySelector('#email');
    const phoneNumberEl       = document.querySelector('#phone_number');
    const productEl           = document.querySelector('#product');
    const productTypeEl       = document.querySelector('#product_type');
    const priceEl             = document.querySelector('#price');
    //const ticketEl            = document.querySelector('#ticket_number');
    const codeEl            = document.querySelector('#code');
    /******************/

    const isRequired = value => value === '' ? false : true;

    const isEmailValid = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const showError = (input, message) => {
        // get the form-field element
        const formField = input.parentElement;
        // add the error class
        formField.classList.remove('success');
        formField.classList.add('error');

        // show the error message
        const error = formField.querySelector('small');
        error.textContent = message;
    };

    const showSuccess = (input) => {
        // get the form-field element
        const formField = input.parentElement;
        //console.log(formField);
        // remove the error class
        formField.classList.remove('error');
        formField.classList.add('success');

        // hide the error message
        const error = formField.querySelector('small');
        error.textContent = '';
    };

    const checkName = () => {
        let valid = false;
        const firstName = firstNameEl.value.trim();

        if (!isRequired(firstName)) {
            showError(firstNameEl, 'Es necesario ingresar el nombre.');
        } else {
            showSuccess(firstNameEl);
            valid = true;
        }
        return valid;
    };

    const checkLastName = () => {
        let valid = false;
        const lastName = lastNameEl.value.trim();

        if (!isRequired(lastName)) {
            showError(lastNameEl, 'Es necesario ingresar el apellido paterno.');
        } else {
            showSuccess(lastNameEl);
            valid = true;
        }
        return valid;
    };

    const checkEmail = () => {
        let valid = false;
        const email = emailEl.value.trim();
        if (!isRequired(email)) {
            showError(emailEl, 'Es necesario ingresar un email.');
        } else if (!isEmailValid(email)) {
            showError(emailEl, 'Email es invalido.')
        } else {
            showSuccess(emailEl);
            valid = true;
        }
        return valid;
    };

    const checkPhoneNumber = () => {
        let valid = false;
        const phone = phoneNumberEl.value.trim();

        if (!isRequired(phone)) {
            showError(phoneNumberEl, 'Es necesario ingresar número de teléfono.');
        } else {
            showSuccess(phoneNumberEl);
            valid = true;
        }
        return valid;
    };

    const checkProduct = () => {
        let valid = false;
        const product = productEl.value.trim();

        console.warn(product)

        if (!isRequired(product)) {
            showError(productEl, 'Es necesario ingresar el producto.');
        } else {
            showSuccess(productEl);
            valid = true;
        }
        return valid;
    };

    const checkProductType = () => {

        let valid = false;
        const product_type = productTypeEl.value.trim();

        if (!isRequired(product_type)) {
            showError(productTypeEl, 'Es necesario ingresar tipo.');
        } else {
            showSuccess(productTypeEl);
            valid = true;
        }
        return valid;
    };

    const checkPrice = () => {

        let valid = false;
        const price = priceEl.value.trim();

        if (!isRequired(price)) {
            showError(priceEl, 'Es necesario ingresar precio.');
        } else {
            showSuccess(priceEl);
            valid = true;
        }
        return valid;
    };

    const checkTicket = () => {

        let valid = false;
        const ticket = ticketEl.value.trim();

        if (!isRequired(ticket)) {
            showError(ticketEl, 'Es necesario ingresar tipo.');
        } else {
            showSuccess(ticketEl);
            valid = true;
        }
        return valid;
    };

const checkCode = () => {

    let valid = false;
    const code = codeEl.value.trim();

    if (!isRequired(code)) {
        showError(codeEl, 'Es necesario ingresar tipo.');
    } else {
        showSuccess(codeEl);
        valid = true;
    }
    return valid;
};


    // Waits for user to pause typing before validate
    const debounce = (fn, delay = 500) => {
        let timeoutId;
        return (...args) => {
            // cancel the previous timer
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            // setup a new timer
            timeoutId = setTimeout(() => {
                fn.apply(null, args)
            }, delay);
        };
    };

    if(regForm){
        regForm.addEventListener('input', debounce(function (e) {
            switch (e.target.id) {
                case 'first_name':
                    checkName();
                    break;
                case 'last_name':
                    checkLastName();
                    break;
                case 'phone':
                    checkPhoneNumber();
                    break;
                case 'email':
                    checkEmail();
                    break;
                case 'product':
                    checkProduct();
                    break;
                case 'product_type':
                    checkProductType();
                    break;
                case 'price':
                    checkPrice();
                    break;
                //case 'ticket_number':
                //    checkTicket();
                //    break;
                case 'code':
                    checkCode();
                    break;
            }
        }));
    }

$('#reg-submit').click(function(e) {
    // Validación de formulario
    if (!e.detail || e.detail == 1) {
        let
            isNameValid = checkName(),
            isLastNameValid = checkLastName(),
            isPhoneValid = checkPhoneNumber(),
            isProductValid = checkProduct(),
            isProductTypeValid = checkProductType(),
            isPriceValid = checkPrice(),
            isEmailValid = checkEmail(),
            isCode = checkCode();

        let isFormValid = isNameValid && isLastNameValid && isProductValid && isProductTypeValid &&
            isPhoneValid && isPriceValid && isEmailValid && isCode;

        if (isFormValid) {
            console.log("isFormValid");
            swal({
                title: '¿SE CREARÁ LA GARANTÍA ESTAS DE ACUERDO?',
                icon: 'info',
                text: '.',
                buttons: {
                    cancel: "Cancelar",
                    confirm: "Confirmar"
                }
            }).then((isConfirmed) => {
                if (isConfirmed) {
                    e.preventDefault();

                    swal({
                        title: "Enviando...",
                        text: "Por favor espera",
                        icon: "info",
                        buttons: false,
                        allowOutsideClick: false
                    });

                    // Usar FormData para incluir la imagen en la solicitud AJAX
                    var formReg = document.getElementById('pre-registration');
                    var formData = new FormData(formReg);  // Crear el FormData con el formulario completo

                    // Enviar la solicitud AJAX usando FormData
                    $.ajax({
                        url: formReg.action,
                        type: formReg.method,
                        data: formData,
                        processData: false, // Necesario para enviar FormData
                        contentType: false, // Necesario para enviar FormData
                        success: function(response) {
                            swal({
                                title: "¡GARANTÍA REGISTRADA CON ÉXITO!",
                                text: ".",
                                icon: 'success',
                                confirmButtonText: 'Aceptar',
                                showConfirmButton: true
                            }).then(function() {
                                window.location = "/";
                            });
                        },
                        error: function(xhr, status, error) {
                            let msj_error = '';
                            if (xhr.responseText !== undefined && xhr.responseText !== '') {
                                $.each(xhr.responseJSON, function(index, value) {
                                    msj_error += '' + index + ': ' + value + '\n';
                                });
                            }
                            swal({
                                title: "Hubo un error al registrar, intenta de nuevo...\n ",
                                text: `${msj_error}`,
                                icon: 'error',
                                confirm: {
                                    text: "Aceptar",
                                    value: true,
                                    visible: true,
                                    className: "",
                                    closeModal: true
                                }
                            });
                        }
                    });
                }
            });
        } else {
            console.log("isFormInvalid");
            swal({
                title: "¡UPS!",
                text: "Parece que aún hay campos por llenar, verifica tu información e intenta de nuevo.",
                icon: 'warning',
                confirm: {
                    text: "Aceptar",
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: true
                }
            });
        }
    }
});



/*    /!** REGISTRATION FORM **!/
    $('#reg-submit').click(function(e){
        // validate forms
        if(!e.detail || e.detail == 1){
            let
                isNameValid = checkName(),
                isLastNameValid = checkLastName(),
                isPhoneValid = checkPhoneNumber(),
                isProductValid = checkProduct(),
                isProductTypeValid = checkProductType(),
                isPriceValid = checkPrice(),
                //isTicketValid = checkTicket(),
                isEmailValid = checkEmail(),
                isCode = checkEmail();

            let isFormValid = isNameValid && isLastNameValid && isProductValid && isProductTypeValid &&
                isPhoneValid && isPriceValid && isEmailValid && isCode;

            if(isFormValid){
                console.log("isFormValid")
                swal({
                    title: '¿SE CREARÁ LA GARANTÍA ESTAS DE ACUERDO?',
                    icon: 'info',
                    text: '.',
                    buttons: {
                        cancel: I18n.t('messages.cancel'),
                        confirm: I18n.t('messages.confirm')
                    }
                }).then((isConfirmed) => {
                    if (isConfirmed) {
                        // Select the form element
                        var formReg = $('form#pre-registration');

                        // Bind a function to the submit event
                        formReg.submit(function(event) {
                            // Prevent the default form submission behavior
                            event.preventDefault();

                            swal({
                                title: "Enviando...",
                                text: "Por favor espera",
                                icon: "info",
                                //showConfirmButton: false,
                                buttons:           false,
                                allowOutsideClick: false
                            });

                            // Use FormData to include the image in the AJAX request
                            //var formData = new FormData(formReg[0]);  // Pass the form element to FormData

                            var formData = new FormData(formReg);  // Crear el FormData con el formulario completo

                            console.warn('*******')
                            console.warn(formReg[0]);
                            console.warn('22222')
                            console.warn(formReg.serialize());
                            // Send an AJAX request to submit the form data
                            $.ajax({
                                url: formReg.attr('action'),
                                type: formReg.attr('method'),
                                data: formData,
                                //data: formReg.serialize(),
                                success: function(response) {
                                    swal({
                                        title: "¡GARANTIA REGISTRADA CON ÉXITO!",
                                        text: ".",
                                        icon: 'success',
                                        confirmButtonText: 'Aceptar',
                                        showConfirmButton: true
                                    }).then(function() {
                                        window.location = "/";
                                    });
                                },
                                error: function(xhr, status, error) {
                                    let msj_error = ''
                                    if(xhr.responseText !== undefined || xhr.responseText !== '')
                                    {
                                        $.each(xhr.responseJSON, function(index, value) {
                                            msj_error += '' + index + ': ' + value + '\n'
                                        });
                                    }
                                    swal({
                                        title: "Hubo un error al registrar, intenta de nuevo...\n ",
                                        text: `${msj_error}`,
                                        icon: 'error',
                                        confirm: {
                                            text: "Aceptar",
                                            value: true,
                                            visible: true,
                                            className: "",
                                            closeModal: true
                                        }
                                    });
                                }
                            });
                        });

                        formReg.submit();
                    }
                }).catch(e.preventDefault());
            } else {
                console.log("isFormInnnvalid")
                swal({
                    title: "¡UPS!",
                    text: "Parece que aún hay campos por llenar, verifica tu información e intenta de nuevo.",
                    icon: 'warning',
                    confirm: {
                        text: "Aceptar",
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: true
                    }
                });
            }
        }

    });
    */

// });
